import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type WholeHomeWifiContentState = {
    WholeHomeWifiContent: any;
    loading: boolean;
    error: any;
}

const initialState: WholeHomeWifiContentState = {
    WholeHomeWifiContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "whole-home-wifi.json";

export const getWholeHomeWifiContent = createAsyncThunk(
    "get/whole-home-wifi/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const WholeHomeWifiSlice = createSlice({
    name: "whole-home-wifi/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getWholeHomeWifiContent.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getWholeHomeWifiContent.fulfilled, (state, action) => {
            state.WholeHomeWifiContent = action.payload;
            state.loading = false;
            state.error = null;
        })
        builder.addCase(getWholeHomeWifiContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Fiber_EC_Flow",
                "WholeHomeWifi-content",
                action?.error?.message,
                action?.type
            );
            state.WholeHomeWifiContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default WholeHomeWifiSlice.reducer;